<template>
  <div class="flex-col justify-start relative page">
    <div class="flex-col justify-start items-center">
      <img class="image_1" src="@/assets/imglv1/obituary/bg1.png" />
      <!-- <img class="image_2" src="@/assets/imglv1/obituary/bg.gif" /> -->
    </div>
    <div class="content">
      <div class="content_l">
        <div class="wztop">
          <div class="bt" @click="back">
            <!-- <div style="padding-right: 60px;">讣</div>
            <div>告</div> -->
            生平简介
          </div>
          <!-- <div class="biaoq">哀思</div> -->
        </div>

        <div class="wzbto">
          <div class="wzbtoCont" v-html="details.obituary">

          </div>
          <!-- <div class="wzbtoCont" v-html="details.biography">

          </div> -->
        </div>

      </div>
      <div class="content_r">
        <div class="img">
          <img class="avaterImg" :src="details.image" alt="">
          <img class="HuaImg" src="@/assets/imglv1/obituary/flower.png" alt="">
          <!-- <img class="HuaImg" src="@/assets/imglv1/obituary/flower.gif" alt=""> -->
        </div>
        <div class="name">
          <div v-if="details.m">{{ details.m }}</div>
          <div>{{ details.name }}</div>
        </div>
        <!-- <div class="logoHua">
          <img class="logoHuaImg" src="@/assets/imglv1/obituary/flowers.png" alt="">
        </div> -->
      </div>

      <!-- <div class="contentewm">

      </div> -->
    </div>
    <div class="danmu">
      <!--插件地址  https://www.npmjs.com/package/vue-danmaku -->
      <vue-danmaku v-if="danmushow" v-model="list" useSlot style="height:100%; width:100%;" :performance="true"
        :speeds="200" :autoplay="false" ref="danmaku" :debounce="800" :channels="2" @play-end="playend">
        <template slot="dm" slot-scope="{ index, danmu }">
          <div class="list" v-if="danmu.type == 1 || danmu.type == 2 || danmu.type == 3">
            <div class="wz wzbg5" v-show="danmu.type == 1">
              <div class="h_center">
                <div class="h_center clol6">
                  <div>{{ danmu.nickname }}</div>
                  <div>送了一朵{{ danmu.oblation_name }}</div>
                </div>
                <img :src="danmu.image" alt="">
              </div>
            </div>
            <div class="wz wzbg5" v-show="danmu.type == 2">
              <div class="h_center">
                <div class="h_center clol6">
                  <div>{{ danmu.nickname }}</div>
                  <div>上了一炷{{ danmu.oblation_name }}</div>
                </div>
                <img :src="danmu.image" alt="">
              </div>
            </div>
            <div class="wz wzbg5" v-show="danmu.type == 3">
              <div class="h_center">
                <div class="clol6">{{ danmu.nickname }}说:{{ danmu.content }}</div>
                <div style="height: 40px;"></div>
              </div>
            </div>
          </div>

        </template>
      </vue-danmaku>
    </div>

    <div class="ewm-bt" :class="{ ewmCenter: !hasTools }">
      <img :src="ewm" alt="" class="ewm" />
      <div>
        <div class="ewm-icon">扫码祭奠</div>
      </div>
    </div>

    <img class="flower1" src="@/assets/imglv1/obituary/flower1.gif" alt="">

    <KongmingLantern></KongmingLantern>
  </div>
</template>
<script>
import QRCode from "qrcode";
import vueDanmaku from 'vue-danmaku';
import { detileGet, getList, obituaryGet } from "@/api/go";
import KongmingLantern from '@/components/vfx/KongmingLantern';
import { connectWebsocket, closeWebsocket, sendMsg } from "@/config/websocket.js";

export default {
  components: {
    vueDanmaku,
    KongmingLantern
  },
  beforeRouteEnter(to, from, next) {
    let s = to.query.s;
    if (s) {
      if (s == 1) {
        next({
          name: "index",
          query: to.query
        });
      } else if (s == 2) {
        next({
          name: "farewell",
          query: to.query
        });
      } else if (s == 3) {
        next();
      }
    } else {
      next();
    }
  },
  data() {
    return {
      id: "",
      ewm: "",
      list: [],
      hasTools: !this.$route.query.s,
      page: 1,
      motif: 1,
      details: '',
      timer: '',
      timer2: '',
      danmushow: true,
    };
  },
  mounted() {
    this.motif = localStorage.getItem('motif') || 1
  },
  computed: {

  },
  watch: {

  },
  methods: {
    playend() {
      // console.log('弹幕到底了')
      let that = this
      this.danmushow = false
      // console.log(this.list)
      this.timer3 = setTimeout(() => {
        that.danmushow = true
        that.$nextTick(() => {
          that.$refs.danmaku.play()
        });
      }, 1000 * 3);
    },
    // 二维码生成
    getEWM() {
      // console.log(location.origin + `/mobilelt?id=${this.id}&SweetShow=${this.details.belief}`)
      // SweetShow 区分是否展示上香  有些情况不展示上香
      QRCode.toDataURL(
        location.origin + `/mobilelt?id=${this.id}&SweetShow=${this.details.belief}`
      )
        .then(url => {
          this.ewm = url;
        })
        .catch(err => {
          console.error(err);
        });
    },
    getLiuyan() {
      getList({
        userId: Number(this.id),
        page: this.page,
        limit: 20,
        device: 'pc'
      }).then(res => {
        if (res.data.length == 0) {
          return
        }
        let array2 = res.data
        this.list = this.list.concat(array2)
        // console.log(this.list)
        if (this.page < res.totalPage || res.data.length == 20) {
          this.page++
          this.getLiuyan()
        } else {
          this.initWebSocket(res.lastId);
          this.$nextTick(() => {
            this.$refs.danmaku.play()
          });
        }
      }).catch(err => {

      });
    },
    getURL(url) {
      if (!url) {
        return url;
      }
      if (url.includes("http")) {
        return url;
      } else {
        return `https://immortal-space.oss-cn-hangzhou.aliyuncs.com` + url;
      }
    },
    back() {
      this.$router.replace({
        name: "list",
        query: {
          id: this.id
        }
      });
    },
    // 获取信息
    detileData(ty) {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      obituaryGet({
        userId: Number(this.id)
      }).then(res => {
        this.details = res
        if (ty) {
          this.getEWM();
        }
        this.timer = setTimeout(() => {
          this.detileData()
        }, 1000 * 60 * 10);
      }).catch(err => {

      });

      // detileGet({
      //   userId: Number(this.id)
      // }).then(res => {
      //   console.log(res)
      //   if (res.auth_config) {

      //     this.details = res

      //     if (ty) {
      //       this.getEWM();
      //     }
      //     this.timer = setTimeout(() => {
      //       this.detileData()
      //     }, 1000 * 60 * 10);
      //   }
      // }).catch(err => {

      // });
    },


    initWebSocket(mid) {
      // mid 最后一条弹幕id 长连接用
      let data = {
        userid: Number(this.id),//逝者ID
        mid: mid ? mid : 0,
      }
      connectWebsocket("wss://api.szskapp.com/spaceDialogue/ws2", data, (ret) => {
        if (ret) {
          console.log('收到数据', ret)
          let res = JSON.parse(ret)
          if (res.data) {
            let array1 = this.list
            let array2 = res.data
            // 提取 array2 中 id 不在 array1 中的对象
            let uniqueInArray2 = array2.filter(item2 =>
              !array1.some(item1 => item1.id === item2.id)
            );
            if (uniqueInArray2.length > 0) {
              this.list = this.list.concat(uniqueInArray2)
            }
          }

        }
      },
        (err) => {
          // console.log("Socket断开");
        })
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.getLiuyan();
    this.detileData(1)
    // console.log('加载')
    // 每4小时刷新页面 反正内存超出
    this.timer2 = setTimeout(() => {
      // console.log('刷新')
      this.$router.replace({
        name: "obituary",
        query: {
          id: this.id,
          time: Date.parse(new Date())
        }
      });
      window.location.reload()
    }, 1000 * 60 * 60 * 4);
  },
  beforeDestroy() {
    // console.log('销毁')
    clearInterval(window.timer);
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.timer2) {
      clearInterval(this.timer2);
      this.timer2 = null;
    }
    if (this.timer3) {
      clearInterval(this.timer3);
      this.timer3 = null;
    }
    closeWebsocket()
  }
};
</script>
<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;
  position: relative;

  .image_1 {
    width: 100vw;
    height: 100vh;
  }

  .image_2 {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 20;
  }
}


.content {
  display: flex;
  // justify-content: space-between;
  position: fixed;
  // left: 130px;
  left: 50%;
  // right: 106px;
  transform: translateX(-50%);
  top: 70px;
  z-index: 999 !important;

  .content_l {
    width: 1007.5px;

    .wztop {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      margin: 0 auto;

      .bt {
        font-size: 80px;
        padding-right: 15px;
        font-weight: bold;
        cursor: pointer;
        // font-weight: bold;
        display: flex;
      }

      .biaoq {
        width: 72px;
        height: 123px;
        background: url(~@/assets/imglv1/obituary/icon1.png);
        background-size: 100% 100%;
        font-size: 28px;
        text-align: center;
        line-height: 72px;
        writing-mode: vertical-rl;
        letter-spacing: 8px;
      }
    }

    .wzbto {
      padding-top: 40px;
      font-size: 50px;
      // line-height: 80px;
      color: #fff;
      // text-align: right;

      .wzbtoCont {
        // display:inline-block;
        // text-align: justify;
        // text-align-last: justify;
         /* 启用等宽特性 */
         font-feature-settings: "tnum", "onum", "pnum", "lnum", "zero", "ss01", "ss02", "ss03", "ss04", "ss05", "ss06", "ss07", "ss08";
      }
    }
  }

  .content_r {
    padding-left: 120px;
    padding-top: 60px;

    // transform: scale(0.95);
    .img {
      width: 600px;
      height: 600px;
      position: relative;

      // transform: scale(1.15);
      .avaterImg {
        width: 100%;
        height: 100%;

        border-radius: 50%;
      }

      .HuaImg {
        position: absolute;
        bottom: -50px;
        right: 10px;
        width: 240px;
      }
    }

    .name {
      padding: 10px 0;
      // width: 648px;
      // background: #000;
      // height: 69px;
      // border-radius: 50px;
      // border: 4px solid #fff;
      margin-top: 40px;
      font-size: 65px;
      display: flex;
      justify-content: center;
      color: #fff;
      text-align: center;

      div {
        margin: 0 30px;
      }
    }

    .logoHua {
      margin: 0 auto;
      margin-top: 10px;
      text-align: center;

      .logoHuaImg {
        width: 500px;
        // height: 119px;
      }
    }
  }
}


.danmu {
  position: fixed;
  bottom: 40px;
  left: 0;
  right: 11%;
  height: 15%;
  z-index: 20 !important;

  .list {
    margin-bottom: 32px;
    font-size: 28px;
    color: #000000;

    .wz {
      padding: 10px 14px;
      border-radius: 50px;
      display: inline-block;
      line-height: 50px;

      img {
        height: 40px;
        margin-left: 10px;
      }
    }

    .wzbg5 {
      background: rgba(0, 0, 0, 0.5);
    }

    .wzbg6 {
      background: #FF9672;
    }
  }
}

.clol5 {
  color: #fff;
}

.clol6 {
  color: #fff;
}

.h_center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.contentewm {}

.ewm {
  width: 160px;
  height: 160px;
  border-radius: 8px;
}

.ewm-icon {
  margin: 0 auto;
  // width: 230px;
  // margin-top: 20px;
  color: #fff;
  text-align: center;
  font-size: 35px;
  font-weight: bold;
  font-family: KaiTi;
}

.ewm-bt {
  position: fixed;
  right: 40px;
  bottom: 50px;
  z-index: 30;
}

.flower1 {
  position: fixed;
  left: 160px;
  bottom: 30px;
  width: 400px;
  z-index: 10;
}
</style>